import * as Sentry from '@sentry/node';

export const logger = {
  error: (...args: Parameters<typeof Sentry.captureException>) => {
    Sentry.captureException(...args);
    // eslint-disable-next-line no-console
    console.error(...args);
  },
};
